import {compose as composeDefault, createStore, applyMiddleware} from 'redux'
import {composeWithDevTools} from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import rootReducer from '../reducers'

// configure persist
import {persistStore, persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage/session'

const persistConfig = {
    key: 'wecan-app',
    storage
};

const reducers = persistReducer(persistConfig, rootReducer);

// configure store
const compose = process.env.NODE_ENV !== 'production'
    ? composeWithDevTools
    : composeDefault;

const middleware = [thunk]

const store = createStore(reducers, compose(applyMiddleware(...middleware)))

export const configureStore = () => {
    const persistor = persistStore(store)

    return {store, persistor}
}

export default store


// WEBPACK FOOTER //
// ./src/data/store.js